module.exports = __webpack_public_path__ + "static/media/480.bc81aa61.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-housekeeping/dark/480.png
// module id = 2176
// module chunks = 2